// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import zoomInIcon from "@/assets/icons/zoom-in.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ZoomInIconProps = Omit<IconProps, "name">;

export function ZoomInIcon(props: ZoomInIconProps): React.ReactNode {
  return <Icon name={zoomInIcon} {...props} />;
}
